import Vue from "vue"
import API from "@/api"
import websocket from "@/websocket"
import errorLogger from "@/utils/errorLogger"

function initSockets(owner) {
  websocket.on(`${owner}:tournamentCreated`, tournament => {
    Vue.notify({
      group: "events",
      type: "tournamentCreated",
      text: tournament.address
    })
  })
  websocket.on(`${owner}:tournamentUpdated`, tournament => {
    Vue.notify({
      group: "events",
      type: "tournamentUpdated",
      text: tournament.address
    })
  })
  websocket.on(`${owner}:tournamentNewSubmission`, submission => {
    Vue.notify({
      group: "events",
      type: "tournamentNewSubmission",
      text: submission.tournament
    })
  })
  websocket.on(`${owner}:submissionCreated`, submission => {
    Vue.notify({
      group: "events",
      type: "submissionCreated",
      text: submission.hash
    })
  })
  websocket.on(`${owner}:submissionRewarded`, submission => {
    Vue.notify({
      group: "events",
      type: "submissionRewarded",
      text: submission.hash
    })
  })
  websocket.on(`${owner}:commitCreated`, commit => {
    Vue.notify({
      group: "events",
      type: "commitCreated",
      text: commit.hash
    })
  })
}

const state = {
  ethAddress: ""
}

export const mutations = {
  SET_USER(state, payload) {
    if (!payload) {
      return Object.keys(state).forEach(key => {
        state[key] = null
      })
    }
    Object.assign(state, payload)
  }
}

export const actions = {
  async restoreSession({ commit, dispatch }) {
    const token = localStorage.getItem("mtx-token")
    if (!token) return

    const payload = JSON.parse(atob(token.split(".")[1]))
    if (payload.exp * 1000 < Date.now()) {
      localStorage.removeItem("mtx-token")
      return
    }

    const { success, data } = await API.me()
    if (!success || !data) return

    const { user } = data
    if (!user) return

    commit("SET_USER", user)

    const [ethAddress] = await window.ethereum.enable()
    if (!ethAddress || user.ethAddress !== ethAddress) {
      dispatch("logout")
    } else {
      dispatch("checkWeb3")

      initSockets(ethAddress.toLowerCase())

      window.ethereum.on("accountsChanged", (addresses) => {
        if (state.ethAddress !== addresses[0]) {
          dispatch("logout")
        }
      })
    }
  },

  async login({ commit, dispatch }) {
    try {
      const [ethAddress] = await window.ethereum.enable()

      const { success: secretSuccess, data: secretResults } = await API.requestSecret()
      if (!secretSuccess) return

      const hex = window.web3.fromAscii(secretResults.secret)
      const signature = await new Promise((resolve, reject) => {
        window.web3.personal.sign(hex, ethAddress, (err, sig) => {
          if (err) {
            return reject(err)
          }
          resolve(sig)
        })
      })

      const { success: loginSuccess, data: loginResults } = await API.login({
        owner: ethAddress,
        signature,
        token: secretResults.token
      })
      if (!loginSuccess) return

      const { user, token } = loginResults
      localStorage.setItem("mtx-token", token)
      commit("SET_USER", user)
      dispatch("checkWeb3")

      initSockets(ethAddress.toLowerCase())

      window.ethereum.on("accountsChanged", (addresses) => {
        if (state.ethAddress !== addresses[0]) {
          dispatch("logout")
        }
      })
    } catch (error) {
      if (error.message.includes("User denied message signature")) return
      errorLogger.log(error)
      Vue.notify({
        title: "Error",
        text: error.message,
        type: "error"
      })
    }
  },

  async editUser({ commit, dispatch }, edits) {
    const { success, data } = await API.editUser(edits)
    if (success) {
      commit("SET_USER", data.user)
      dispatch("checkWeb3")
    }

    return { success, data }
  },

  logout({ commit, dispatch }) {
    localStorage.removeItem("mtx-token")
    websocket.removeAllListeners()
    commit("SET_USER", null)
    dispatch("checkWeb3")
  }
}

export default {
  state,
  mutations,
  actions
}
